import { render } from "./simpleSms.vue?vue&type=template&id=c75c635a&scoped=true"
import script from "./simpleSms.vue?vue&type=script&lang=js"
export * from "./simpleSms.vue?vue&type=script&lang=js"

import "./simpleSms.vue?vue&type=style&index=0&id=c75c635a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75c635a"]])

export default __exports__